<template>
  <div id="ParentProductAnalysis" style="margin: 0 auto; background: white">
    <div>
      <div ref="chartBox" class="chart-box"></div>
    </div>
    <div ref="header" class="header-box">
      <span class="header-label">产品类型</span>
      <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
        <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
      </el-select>
      <span class="header-label">产品颜色</span>
      <el-select placeholder="产品类型" size="small" v-model="params.productColor">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
      </el-select>
      <span class="header-label">机型</span>
      <el-select placeholder="机型" size="small" v-model="params.productModel">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
      </el-select>
      <span class="header-label">SKU</span>
      <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku"> </el-input>
      <el-button type="primary" size="small" @click="queryBtn">查询</el-button>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="每日明细" name="dayList"></el-tab-pane>
      <el-tab-pane label="SKU明细" name="skuList"></el-tab-pane>
      <el-tab-pane label="颜色明细" name="colorList"></el-tab-pane>
      <el-tab-pane label="机型明细" name="modelList"></el-tab-pane>
      <el-tab-pane label="关键词明细" name="keywordList"></el-tab-pane>
      <el-tab-pane label="修改明细" name="editList"></el-tab-pane>
    </el-tabs>

    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true">
      <el-table-column v-if="activeName == 'dayList'" prop="date" label="日期" width="80px" align="right" sortable> </el-table-column>
      <!-- <el-table-column prop="seller-sku" label="SKU" width="200px" align="center" sortable>
      </el-table-column> -->
      <el-table-column prop="productName" label="名称" width="70px" align="right" sortable> </el-table-column>
      <el-table-column v-if="activeName == 'skuList'" prop="seller-sku" label="SKU" width="200px" align="right" sortable>
        <template v-slot="scope">
          <div @click="params.sku = scope.row['seller-sku']">{{ scope.row["seller-sku"] }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="activeName == 'modelList'" prop="model" label="机型" width="60px" align="right" sortable> </el-table-column>
      <el-table-column v-if="activeName == 'colorList' || activeName == 'skuList'" prop="productColorName" label="颜色" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="speed" label="增速" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="inventoryCount" label="库存" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="availableQuantity" label="可用" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="reservedQuantity" label="预留" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="recommendCount" label="采购" width="40px" align="right" sortable> </el-table-column> -->
      <el-table-column prop="sessions" label="合计访客" class-name="lightBlueBg" width="55px" align="right" sortable> </el-table-column>
      <!-- <el-table-column prop="pageViews" label="页面浏览量" class-name="lightBlueBg" width="60px" align="right" sortable>
      </el-table-column> -->
      <el-table-column prop="orders" label="当日订单" class-name="lightBlueBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="rank" label="排名" class-name="lightBlueBg" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="competitionRank" label="竞品排名" width="60px" align="right" :key="1222" sortable> </el-table-column>
      <el-table-column prop="orderRate" label="转化率" class-name="lightBlueBg" width="50px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate >= 0 ? (Math.round(scope.row.orderRate * 10000) / 100).toFixed(2) + "%" : "0.00%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="last7DayCount" label="七日订单" class-name="lightBlueBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="price" label="价格" class-name="lightBlueBg" width="40px" align="right" sortable> </el-table-column>
      <el-table-column prop="competitionRank" label="竞品排名" width="40px" align="right" :key="2225" sortable> </el-table-column>
      <el-table-column prop="competitionUnitPrice" label="竞品价格" width="40px" align="right" :key="1225" sortable> </el-table-column>
      <el-table-column prop="normalVisit" label="自然访客" class-name="lightGreenBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="normalOrders" label="自然订单数" class-name="lightGreenBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="normalConversionRate" label="自然转化率" class-name="lightGreenBg" width="50px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.normalConversionRate >= 0 ? (Math.round(scope.row.normalConversionRate * 10000) / 100).toFixed(2) + "%" : "0.00%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="adImpressions" label="广告展现" class-name="lightYellowBg" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="adVisit" label="广告访客" class-name="lightYellowBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="adConversionRate" label="广告转化率" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.adConversionRate >= 0 ? (Math.round(scope.row.adConversionRate * 10000) / 100).toFixed(2) + "%" : "0.00%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="adOrders" label="广告订单数" class-name="lightYellowBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="total7DayAdSkuCount" label="本SKU订单数" class-name="lightYellowBg" width="50px" align="right" sortable> </el-table-column>
      <el-table-column prop="adSpend" label="广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.adSpend).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adSales" label="广告销售额" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.adSales).toFixed(2) }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="adCpc" label="广告CPC" width="50px" class-name="lightYellowBg" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adCpc)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adClickRate" label="广告点击率" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adClickRate*100)).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="adConversionRate" label="广告转化率" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adConversionRate*100)).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="adROAS" label="广告ROAS" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adROAS)).toFixed(2)  }}
        </template>
      </el-table-column>
      <el-table-column prop="adManualKWSpend" label="手动关键词广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adManualKWSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adAutoCloseSpend" label="紧密匹配广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adAutoCloseSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adAutoLooseSpend" label="广泛匹配广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adAutoLooseSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="recommendPrice" label="推荐价格" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getRecommendPriceStyleClass(scope.row)">{{ scope.row.recommendPrice }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="sum" label="广告状态" width="60px" align="right">
        <template v-slot="scope">
          <el-switch v-model="scope.row.adState" active-value="enabled" inactive-value="paused" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models } from "../../utils/constant.js";
import * as echarts from "echarts";
import Utils from "../../utils/utils.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 68,
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      tableData: [],
      productType: this.$route.query.productType,
      productColor: this.$route.query.productColor,
      params: {
        sku: "",
        viewType: 2,
        productType: ~~this.$route.query.productType,
        productColor: "",
        productModel: "",
        beginIndex: 0,
        pageSize: 10000,
      },
      dateList: [],
      activeName: "dayList",
      chartOptions: {
        legend: {
          top: 10,
          left: "center",
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(item => {
              if (item.seriesName === "访客") {
                const originalValue = item.value * this.visitScale;
                result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}%<br/>`;
              } else if (item.seriesName === "订单") {
                const originalValue = item.value * this.orderScale;
                result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}<br/>`;
              }
              result += `${item.marker} ${item.seriesName}: ${originalValue}%<br/>`;
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      },
      chartData: {},
      dates: [],
      date: null,
      visitScale: 1,
      orderScale: 1,
      orderRateScale: 1,
      priceScale: 1,
      impressionsScale: 1,
      adSpendScale: 1,
    };
  },
  mounted() {
    if (this.params.productType <= 0) {
      this.params.productType = 1;
    }

    this.initDefaultDate();
    this.getData();
    // this.getChartData()
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    queryBtn() {
      this.getData();
      // this.getChartData()
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 68;
    },
    initDefaultDate() {
      if (this.date) {
        return;
      }

      let hours = new Date().getHours();
      let offset = 0;
      let usaFirstHour = 16;
      Utils.isDaylightSavingTime() && (usaFirstHour = 15);
      hours < usaFirstHour && (offset = 1);
      if (hours < usaFirstHour) {
        this.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
      } else {
        this.date = new Date().format("yyyy-MM-dd");
      }

      this.initChartDateList();
    },
    initChartDateList() {
      this.dates = [];
      for (let i = 29; i >= 0; i--) {
        let date = new Date(new Date(this.date).getTime() - i * 24 * 60 * 60 * 1000).format("MM-dd");
        this.dates.push(date);
      }
    },
    initChart(chartOptions) {
      var myChart = echarts.init(this.$refs.chartBox);
      myChart.setOption(chartOptions);
    },
    handleClick(tab, event) {
      let name = tab.name;
      name == "dayList" && (this.params.viewType = 2);
      name == "skuList" && (this.params.viewType = 1);
      name == "colorList" && (this.params.viewType = 3);
      name == "modelList" && (this.params.viewType = 5);

      name == "keywordList" && (this.params.viewType = 6);
      this.getData();

      console.log(this.activeName);
    },
    getData() {
      requestModules.fetchProductAnalysisData(this.params).then(res => {
        this.tableData = res.ldata;

        this.getChartData();
      });
    },
    getChartData() {
      requestModules.fetchProductChartData({ productType: this.params.productType, sku: this.params.sku }).then(res => {
        this.initChartData(res.mdata);

        // this.chartData = res.data;
      });
    },
    // initAdChartData(){
    //   let adOrderCountList = [];
    //   let normalOrderCountList = [];
    //   let adOrderRate = [];
    //   let normalOrderRate = [];
    //   let adVisitCount = [];
    //   let normalVisitCount = [];

    //   this.tableData.forEach(data => {
    //     adOrderCountList.push(data.adOrders > 0 ? data.adOrders : 0)
    //     normalOrderCountList.push(data.normalOrders > 0 ? data.normalOrders : 0)
    //     adOrderRate.push(data.adConversionRate > 0 ? data.adConversionRate : 0)
    //     normalOrderRate.push(data.normalConversionRate > 0 ? data.normalConversionRate : 0)
    //     adVisitCount.push(data.adVisit > 0 ? data.adVisit : 0)
    //     normalVisitCount.push(data.normalVisit > 0 ? data.normalVisit : 0)
    //   })
    // },
    initChartData(chartData) {
      let orderCountList = [];
      let adOrderCountList = [];
      let normalOrderCountList = [];
      let orderRateList = [];
      let adOrderRateList = [];
      let normalOrderRateList = [];

      let visitCountList = [];
      let adVisitCountList = [];
      let normalVisitCountList = [];

      for (let i = this.tableData.length - 1; i >= 0; i--) {
        let data = this.tableData[i];
        orderCountList.push(data.orders > 0 ? data.orders : null);
        adOrderCountList.push(data.adOrders > 0 ? data.adOrders : null);
        normalOrderCountList.push(data.normalOrders > 0 ? data.normalOrders : null);
        orderRateList.push(data.orderRate > 0 ? data.orderRate : null);
        adOrderRateList.push(data.adConversionRate > 0 ? data.adConversionRate : null);
        normalOrderRateList.push(data.normalConversionRate > 0 ? data.normalConversionRate : null);
        visitCountList.push(data.sessions > 0 ? data.sessions : null);
        adVisitCountList.push(data.adVisit > 0 ? data.adVisit : null);
        normalVisitCountList.push(data.normalVisit > 0 ? data.normalVisit : null);
      }

      // this.tableData.forEach(data => {
      //   adOrderCountList.push(data.adOrders > 0 ? data.adOrders : 0)
      //   normalOrderCountList.push(data.normalOrders > 0 ? data.normalOrders : 0)
      //   adOrderRateList.push(data.adConversionRate > 0 ? data.adConversionRate : 0)
      //   normalOrderRateList.push(data.normalConversionRate > 0 ? data.normalConversionRate : 0)
      //   adVisitCountList.push(data.adVisit > 0 ? data.adVisit : 0)
      //   normalVisitCountList.push(data.normalVisit > 0 ? data.normalVisit : 0)
      // })

      let adOrderCountScale = this.calcScaleRate(adOrderCountList);
      let adOrderCountFirst = this.getFirstNoZeroData(adOrderCountList);
      let normalOrderCountScale = this.calcScaleRate(normalOrderCountList);
      let normalOrderCountFirst = this.getFirstNoZeroData(normalOrderCountList);
      let adOrderRateScale = this.calcScaleRate(adOrderRateList);
      let adOrderRateFirst = this.getFirstNoZeroData(adOrderRateList);
      let normalOrderRateScale = this.calcScaleRate(normalOrderRateList);
      let normalOrderRateFirst = this.getFirstNoZeroData(normalOrderRateList);
      let adVisitCountScale = this.calcScaleRate(adVisitCountList);
      let adVisitCountFirst = this.getFirstNoZeroData(adVisitCountList);
      let normalVisitCountScale = this.calcScaleRate(normalVisitCountList);
      let normalVisitCountFirst = this.getFirstNoZeroData(normalVisitCountList);

      let visitScale = this.calcScaleRate(chartData.visitList);
      let visitFirst = this.getFirstNoZeroData(chartData.visitList);
      let orderScale = this.calcScaleRate(chartData.orderCountList);
      let orderFirst = this.getFirstNoZeroData(chartData.orderCountList);
      let rankScale = this.calcScaleRate(chartData.rankList);
      let rankFirst = this.getFirstNoZeroData(chartData.rankList);

      let competitionRankScale = this.calcScaleRate(chartData.competitionRankList);
      let competitionRankFirst = this.getFirstNoZeroData(chartData.competitionRankList);
      let orderRateScale = this.calcScaleRate(chartData.orderRateList);
      let orderRateFirst = this.getFirstNoZeroData(chartData.orderRateList);
      let adSpendScale = this.calcScaleRate(chartData.adSpendList);
      let adSpendFirst = this.getFirstNoZeroData(chartData.adSpendList);
      let scoreScale = this.calcScaleRate(chartData.scoreList);
      let scoreFirst = this.getFirstNoZeroData(chartData.scoreList);
      let commentsScale = this.calcScaleRate(chartData.commentsList);
      let commentsFirst = this.getFirstNoZeroData(chartData.commentsList);
      let priceScale = this.calcScaleRate(chartData.priceList);
      let priceFirst = this.getFirstNoZeroData(chartData.priceList);

      //     orderRateList.push(parseFloat((data["orderCount"+i] / data["totalVisit"+i]).toFixed(4)));
      //     adSpendList.push(data["adSpend"+i]);

      // rankList.push(0);
      //       competitionRankList.push(0);
      //       competitionPriceList.push(0);
      //       priceList.push(0);
      //       scoreList.push(0);
      //       commentsList.push(0);

      // console.log(visitScale, orderScale, rankScale)

      let chartOptions = {
        legend: {
          top: 10,
          left: "center",
          selected: {
            排名: true,
            合计访客: false,
            自然访客: false,
            广告访客: false,
            合计订单: false,
            自然订单: false,
            广告订单: false,
            合计成交率: false,
            自然成交率: false,
            广告成交率: false,
            价格: false,
            广告: false,
            竞品排名: false,
            评分: false,
            评论数: false,
            价格: false,
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // 使用 formatter 函数将值转换为百分比
            formatter: function (value) {
              if (value > 1) return value;
              return parseInt(value * 100) + "%"; // 保留两位小数
            },
          },
        },
        series: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(item => {
              if (item.value === undefined) {
              } else {
                let originalValue = 0;
                // if (item.seriesName === '排名') {
                //   originalValue = rankFirst - item.value * rankScale;
                // } else if (item.seriesName === '合计访客') {
                //   originalValue = item.value * visitScale + visitFirst;
                // } else if (item.seriesName === '自然访客') {
                //   originalValue = item.value * normalVisitCountScale + normalVisitCountFirst;
                // } else if (item.seriesName === '广告访客') {
                //   originalValue = item.value * adVisitCountScale + adVisitCountFirst;
                // } else if (item.seriesName === '合计订单') {
                //   originalValue = item.value * orderScale + orderFirst;
                // } else if (item.seriesName === '自然订单') {
                //   originalValue = item.value * normalOrderCountScale + normalOrderCountFirst;
                // } else if (item.seriesName === '广告订单') {
                //   originalValue = item.value * adOrderCountScale + adOrderCountFirst;
                // } else if (item.seriesName === '合计成交率') {
                //   originalValue = item.value * orderRateScale + orderRateFirst;
                //   console.log(item.value, orderRateScale, orderRateFirst)
                // } else if (item.seriesName === '自然成交率') {
                //   originalValue = item.value * normalOrderRateScale + normalOrderRateFirst;
                // } else if (item.seriesName === '广告成交率') {
                //   originalValue = item.value * adOrderCountScale + adOrderRateFirst;
                // } else if (item.seriesName === '广告') {
                //   originalValue = item.value * adSpendScale + adSpendFirst;
                // } else if (item.seriesName === '竞品排名') {
                //   originalValue = competitionRankFirst * 2 - item.value * competitionRankScale;
                // } else if (item.seriesName === '评分') {
                //   originalValue = item.value * scoreScale + scoreFirst;
                // } else if (item.seriesName === '评论数') {
                //   originalValue = item.value * commentsScale + commentsFirst;
                // } else if (item.seriesName === '价格') {
                //   originalValue = item.value * priceScale + priceFirst;
                // }

                originalValue = item.value;

                if (item.seriesName === "合计成交率" || item.seriesName === "自然成交率" || item.seriesName === "广告成交率") {
                  result += `${item.marker} ${item.seriesName}: ${(originalValue * 100).toFixed(2)}%<br/>`;
                } else if (item.seriesName === "广告" || item.seriesName === "评分" || item.seriesName === "价格") {
                  result += `${item.marker} ${item.seriesName}: ${parseFloat(originalValue.toFixed(2))}<br/>`;
                } else {
                  result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}<br/>`;
                }
              }
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      };

      chartOptions.xAxis.data = this.dates;
      chartOptions.series = [
        {
          data: chartData.rankList,
          type: "line",
          smooth: true,
          name: "排名",
        },
        {
          data: visitCountList,
          type: "line",
          smooth: true,
          name: "合计访客",
        },
        {
          data: normalVisitCountList,
          type: "line",
          smooth: true,
          name: "自然访客",
        },
        {
          data: adVisitCountList,
          type: "line",
          smooth: true,
          name: "广告访客",
        },
        {
          data: orderCountList,
          type: "line",
          smooth: true,
          name: "合计订单",
        },
        {
          data: normalOrderCountList,
          type: "line",
          smooth: true,
          name: "自然订单",
        },
        {
          data: adOrderCountList,
          type: "line",
          smooth: true,
          name: "广告订单",
        },
        {
          data: chartData.orderRateList,
          type: "line",
          smooth: true,
          name: "合计成交率",
        },
        {
          data: normalOrderRateList,
          type: "line",
          smooth: true,
          name: "自然成交率",
        },
        {
          data: adOrderRateList,
          type: "line",
          smooth: true,
          name: "广告成交率",
        },
        {
          data: chartData.priceList,
          type: "line",
          smooth: true,
          name: "价格",
        },
        {
          data: chartData.adSpendList,
          type: "line",
          smooth: true,
          name: "广告",
        },
        {
          data: chartData.competitionRankList,
          type: "line",
          smooth: true,
          name: "竞品排名",
        },
        {
          data: chartData.scoreList,
          type: "line",
          smooth: true,
          name: "评分",
        },
        {
          data: chartData.commentsList,
          type: "line",
          smooth: true,
          name: "评论数",
        },
      ];
      this.initChart(chartOptions);
    },
    calcScaleRate(dataList) {
      if (!dataList) {
        return;
      }
      let tempList = dataList.filter(data => data > 0);
      let first = tempList[0];
      tempList.sort((a, b) => a - b);
      let min = tempList[0];
      let max = tempList[tempList.length - 1];
      let rate1 = Math.abs((min - first) / first);
      let rate2 = Math.abs((max - first) / first);

      rate1 == 0 && (rate1 = 1);
      rate2 == 0 && (rate1 = 1);

      // let rate = rate1 > rate2 ? rate1 : rate2;
      let scaleRate = rate1 > rate2 ? min / rate1 : max / rate2;
      return scaleRate;
    },
    getScaledDataList(dataList, scaleRate) {
      let list = [];
      let first = this.getFirstNoZeroData(dataList);

      dataList.forEach(data => {
        data <= 0 && list.push(null);
        data > 0 && list.push((data - first) / scaleRate);
      });
      return list;
    },
    getRankScaledDataList(dataList, scaleRate) {
      let list = [];
      let first = this.getFirstNoZeroData(dataList);
      dataList.forEach(data => {
        data <= 0 && list.push(null);
        data > 0 && list.push((first * 2 - data - first) / scaleRate);
      });
      return list;
    },
    getFirstNoZeroData(dataList) {
      let tempList = dataList.filter(data => data > 0);
      let first = tempList[0];
      return first;
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getAvailableInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 10 && (styleClass = "redBg");
      inventoryDay > 10 && inventoryDay <= 20 && (styleClass = "yellowBg");
      inventoryDay > 20 && inventoryDay <= 60 && (styleClass = "greenBg");
      inventoryDay > 60 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendPriceStyleClass(row) {
      let styleClass = "";
      row.recommendPrice - row.price > 0 && (styleClass = "greenBg");
      row.recommendPrice - row.price < 0 && (styleClass = "redBg");
      return styleClass;
    },
    prevBtnClick() {},
    nextBtnClick() {},
  },
  computed: {
    highlightCellStyle() {
      return {
        backgroundColor: "yellow",
      };
    },
  },
};
</script>

<style lang="scss">
#ParentProductAnalysis {
  .chart-box {
    width: 100%;
    height: 400px;
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
  }

  .el-table tr:hover {
    background-color: #f5f5f5;
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .lightBlueBg {
    background-color: #e5e5ff;
  }
  .lightGreenBg {
    background-color: rgb(198, 239, 198);
  }
  .lightYellowBg {
    background-color: rgb(241, 241, 207);
  }
}
</style>
